/**
 * Wishlist - Fase 1: localStorage (anónimos y logueados).
 * window.Wishlist es la capa de storage abstraída: en Fase 2 se enchufa
 * un driver de customer metafields (App Proxy) sin tocar la UI.
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'tms:wishlist:v1';

  function read() {
    try {
      var items = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) { /* storage lleno o bloqueado: la UI sigue, sin persistencia */ }
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: items.length } }));
  }

  var Wishlist = {
    all: read,
    count: function() { return read().length; },
    has: function(handle) {
      return read().some(function(i) { return i.handle === handle; });
    },
    add: function(item) {
      if (!item || !item.handle) return;
      var items = read();
      if (!items.some(function(i) { return i.handle === item.handle; })) {
        items.push(item);
        write(items);
      }
    },
    remove: function(handle) {
      write(read().filter(function(i) { return i.handle !== handle; }));
    },
    toggle: function(item) {
      if (this.has(item.handle)) {
        this.remove(item.handle);
        return false;
      }
      this.add(item);
      return true;
    }
  };

  window.Wishlist = Wishlist;

  /* ============ i18n + toast ============ */
  var _i18n = null;
  function i18n() {
    if (_i18n) return _i18n;
    var el = document.querySelector('[data-wishlist-i18n]');
    try {
      _i18n = el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      _i18n = {};
    }
    return _i18n;
  }

  var toastEl = null;
  var toastTimer = null;
  function getToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'wl-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.innerHTML = '<span class="wl-toast__message" data-wl-toast-message></span><button type="button" class="wl-toast__action" data-wl-toast-action hidden></button>';
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-visible');
    clearTimeout(toastTimer);
  }

  function showToast(message, action) {
    var toast = getToast();
    var msgEl = toast.querySelector('[data-wl-toast-message]');
    var actionEl = toast.querySelector('[data-wl-toast-action]');
    msgEl.textContent = message;
    if (action && action.label) {
      actionEl.textContent = action.label;
      actionEl.hidden = false;
      actionEl.onclick = function() {
        if (action.onClick) action.onClick();
        else if (action.href) window.location.href = action.href;
        hideToast();
      };
    } else {
      actionEl.hidden = true;
      actionEl.onclick = null;
    }
    toast.classList.add('is-visible');
    if (window.ThemeUtils && ThemeUtils.announce) ThemeUtils.announce(message);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, action ? 5000 : 3000);
  }

  Wishlist.notifyAdded = function() {
    var strings = i18n();
    showToast(strings.added || '', strings.view ? { label: strings.view, href: strings.url } : null);
  };

  Wishlist.notifyRemoved = function(item) {
    var strings = i18n();
    showToast(strings.removed || '', (strings.undo && item) ? {
      label: strings.undo,
      onClick: function() { Wishlist.add(item); syncButtons(); }
    } : null);
  };

  /* ============ UI: contadores y botones ============ */
  function updateCounters() {
    var count = Wishlist.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      var active = Wishlist.has(btn.dataset.handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = active ? btn.dataset.labelRemove : btn.dataset.labelAdd;
      if (label) btn.setAttribute('aria-label', label);
      var labelEl = btn.querySelector('[data-wishlist-label]');
      if (labelEl && label) labelEl.textContent = label;
    });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var snapshot = {
      handle: btn.dataset.handle,
      title: btn.dataset.title,
      url: btn.dataset.url,
      image: btn.dataset.image,
      price: btn.dataset.price,
      compare: btn.dataset.compare || '',
      available: btn.dataset.available !== 'false'
    };
    var added = Wishlist.toggle(snapshot);
    syncButtons();
    if (added) {
      /* Feedback fuerte: abre el drawer en la pestaña Deseos (mismo patrón
         que agregar al carrito). Toast solo como fallback sin drawer. */
      if (window.openWishlistDrawer) {
        window.openWishlistDrawer();
        var strings = i18n();
        if (window.ThemeUtils && ThemeUtils.announce && strings.added) ThemeUtils.announce(strings.added);
      } else {
        Wishlist.notifyAdded();
      }
    } else {
      Wishlist.notifyRemoved(snapshot);
    }
  });

  document.addEventListener('wishlist:change', function() {
    updateCounters();
    syncButtons(); // re-sincroniza estado ♥ en cards insertadas dinámicamente (TS search)
  });
  document.addEventListener('DOMContentLoaded', function() {
    updateCounters();
    syncButtons();
  });

  /* ============ Página /pages/wishlist ============ */
  document.addEventListener('DOMContentLoaded', function() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    var template = page.querySelector('[data-wishlist-card-template]');
    if (!grid || !template) return;

    function renderPage() {
      var items = Wishlist.all();
      grid.innerHTML = '';
      if (empty) empty.hidden = items.length > 0;
      grid.hidden = items.length === 0;

      items.forEach(function(item) {
        var node = template.content.cloneNode(true);
        node.querySelectorAll('[data-w-url]').forEach(function(a) { a.href = item.url; });
        var img = node.querySelector('[data-w-image]');
        if (img) {
          if (item.image) {
            img.src = item.image;
            img.alt = item.title || '';
          } else {
            img.remove();
          }
        }
        var title = node.querySelector('[data-w-title]');
        if (title) title.textContent = item.title || item.handle;
        var price = node.querySelector('[data-w-price]');
        if (price) price.textContent = item.price || '';
        var compare = node.querySelector('[data-w-compare]');
        if (compare) {
          compare.textContent = item.compare || '';
          compare.hidden = !item.compare;
        }
        var soldOut = node.querySelector('[data-w-sold-out]');
        if (soldOut) soldOut.hidden = item.available !== false;
        var addBtn = node.querySelector('[data-wl-add]');
        if (addBtn) {
          addBtn.dataset.handle = item.handle;
          addBtn.dataset.url = item.url;
          var isSoldOut = item.available === false;
          addBtn.disabled = isSoldOut;
          /* Texto → "Agotado" cuando no hay stock (más claro que solo el gris) */
          var addLabel = addBtn.querySelector('[data-wl-add-label]');
          if (addLabel && isSoldOut && addBtn.dataset.soldoutLabel) {
            addLabel.textContent = addBtn.dataset.soldoutLabel;
          }
        }
        var removeBtn = node.querySelector('[data-w-remove]');
        if (removeBtn) removeBtn.dataset.handle = item.handle;
        grid.appendChild(node);
      });
      applyCartState(); // marca "En el carrito ✓" los que ya están en el carrito
    }

    /* Estado del botón: "Agregar al carrito" ↔ "En el carrito ✓" (outline+check).
       El ítem NO sale de deseos al agregar; la cantidad se gestiona en el carrito. */
    function setButtonState(btn, inCart) {
      if (btn.disabled) return; // agotado manda
      btn.classList.toggle('is-in-cart', inCart);
      var label = btn.querySelector('[data-wl-add-label]');
      if (label) label.textContent = inCart
        ? (btn.dataset.addedLabel || 'En el carrito')
        : (btn.dataset.defaultLabel || label.textContent);
      var use = btn.querySelector('[data-wl-add-icon] use');
      if (use) use.setAttribute('href', inCart ? '#icon-check' : '#icon-cart');
    }

    /* Conjunto de handles que están en el carrito (para marcar los botones). */
    var cartHandles = null;
    function applyCartState() {
      if (!cartHandles) return;
      grid.querySelectorAll('[data-wl-add]').forEach(function(btn) {
        setButtonState(btn, cartHandles.has(btn.dataset.handle));
      });
    }
    function syncCartState() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          cartHandles = new Set((cart.items || []).map(function(i) { return i.handle; }));
          applyCartState();
        })
        .catch(function() {});
    }

    grid.addEventListener('click', function(e) {
      /* Agregar al carrito. Si ya está en el carrito, el clic abre el mini-cart
         (para gestionar la cantidad). Multi-variante/agotado → ir al producto. */
      var addB = e.target.closest('[data-wl-add]');
      if (addB && !addB.disabled) {
        e.preventDefault();
        if (addB.classList.contains('is-in-cart')) {
          if (window.openMiniCart) window.openMiniCart();
          return;
        }
        var handle = addB.dataset.handle;
        var url = addB.dataset.url;
        if (!handle || typeof window.addToCart !== 'function') { if (url) window.location.href = url; return; }
        addB.classList.add('is-loading');
        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(p) {
            if (p.variants && p.variants.length === 1 && p.variants[0].available) {
              return window.addToCart(p.variants[0].id, 1).then(function() { setButtonState(addB, true); });
            }
            if (url) window.location.href = url; // varias variantes / agotado → elegir en PDP
          })
          .catch(function() { if (url) window.location.href = url; })
          .finally(function() { addB.classList.remove('is-loading'); });
        return;
      }

      var btn = e.target.closest('[data-w-remove]');
      if (!btn) return;
      e.preventDefault();
      var removed = Wishlist.all().find(function(i) { return i.handle === btn.dataset.handle; });
      Wishlist.remove(btn.dataset.handle);
      renderPage();
      if (removed) Wishlist.notifyRemoved(removed);
    });

    document.addEventListener('wishlist:change', renderPage);
    /* El carrito cambió en otro lado (mini-cart, PDP, /cart) → re-sincroniza el
       estado "En el carrito ✓" de los botones. */
    document.addEventListener('cart:changed', syncCartState);

    /* Revalidar precio/disponibilidad contra la tienda; si el producto
       ya no existe (404), se elimina de la lista. */
    function revalidate() {
      Wishlist.all().forEach(function(item) {
        fetch('/products/' + item.handle + '.js')
          .then(function(r) {
            if (r.status === 404) {
              Wishlist.remove(item.handle);
              renderPage();
              return null;
            }
            return r.ok ? r.json() : null;
          })
          .then(function(product) {
            if (!product) return;
            var items = read();
            var stored = items.find(function(i) { return i.handle === item.handle; });
            if (!stored) return;
            var formatted = ThemeUtils.formatMoney(product.price, page.dataset.moneyFormat);
            var compare = product.compare_at_price > product.price
              ? ThemeUtils.formatMoney(product.compare_at_price, page.dataset.moneyFormat)
              : '';
            var changed = stored.price !== formatted || stored.available !== product.available || stored.compare !== compare;
            stored.price = formatted;
            stored.compare = compare;
            stored.available = product.available;
            stored.title = product.title;
            if (changed) {
              write(items);
              renderPage();
            } else {
              try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
            }
          })
          .catch(function() {});
      });
    }

    renderPage();
    revalidate();
    syncCartState(); // marca los que ya están en el carrito al cargar
  });
})();
